<div class="dashboard__inner" v-if="!isLoading">
    <!--<pre dir="ltr" style="text-align: left">{{ dataItem }}</pre>-->
    <surveyview v-if="ShowQaim" :HeaderText="QaimHeader" :FooterText="QaimFooter"
                :SurveyID="QaimSurveyID" :FirstName="QaimFirstName" :LastName="QaimLastName"
                :BirthDate="QaimBirthDate" :NationalityNumber="QaimNationalityNumber" :NationalityId="QaimNationalityId"
                :Gender="QaimusrGender" Lang="ar" :Config="QaimConfig" :RefNum="dataItem.ApplicationId" @OnSurveyClosed="CloseQaimEvent">

        <template v-slot:header>
            <div class="custom-header-container">
                <div class="Popup__checkMark" style="border: 2px solid;padding: 40px;">

                    <span class="icon icon-check"></span>

                </div>

                <p class="success-message-title">

                    <span>

                        {{ alertText }}

                    </span>

                </p>


                <div class="seperator"></div>
            </div>
        </template>

    </surveyview>

    <div v-if="isDataValid">
        <div v-if="dataItem && !showUpdateSuccessResult">

            <div class="dashboardActionHeading pt-2 px-5">
                <div class="dashboardActionHeading__contentWrapper px-5">
                    <div class="dashboardActionHeading__titleWrapper px-5">
                        <div class="dashboardActionHeading__titleInner">
                            <h3 class="dashboardActionHeading__title ml-3" v-if="dataItem.Status === 2">
                                بيان اعتماد طلب رهن أعيان رقم {{dataItem.ApplicationId}}
                            </h3>
                            <h3 class="dashboardActionHeading__title ml-3" v-else-if="dataItem.Status === 6">
                                تفاصيل طلب رهن أعيان رقم{{dataItem.ApplicationId}}
                            </h3>
                            <h3 class="dashboardActionHeading__title ml-3" v-else>
                                وثيقة اعتماد طلب رهن اعيان
                            </h3>
                            <!-- <h3 class="dashboardActionHeading__title ml-3" v-else>
                                وثيقة اعتماد بيان رهن أعيان {{dataItem.DocumentNumber || dataItem.ApplicationId}}
                            </h3> -->
                            <!-- <h3 class="dashboardActionHeading__title" v-if="dataItem.Status==4">
                                وثيقة بيان اعتماد رهن أعيان
                            </h3> <h3 class="dashboardActionHeading__title" v-if="dataItem.Status==3">
                                وثيقة بيان اعتماد رهن أعيان
                            </h3> -->
                            <div class="dashboardActionHeading__Status mx-3">
                                <span :class="'dashboardActionHeading__status status--'+getStatusColor(dataItem.Status)+' status--bullet status--bulletLeft font-weight-bold'" :style="{color: getStatusColor(dataItem.Status)}">
                                    {{ dataItem.StatusText}}
                                </span>
                            </div>


                        </div>

                        <div class="dashboardActionHeading__titleButtons" v-if="isMortgageIssued">
                            <router-link class="btn btn-sm btn-primary px-3" :to="'/Print/' + dataItem.DocumentNumber">
                                معاينة الوثيقة
                            </router-link>
                        </div>
                    </div>

                    <div class="row mt-3 dashboardActionHeader">
                        <div class="col-lg col-sm-3" v-if="isMortgageIssued">
                            <!-- <span class="dashboardActionHeading__DataLabel mx-3">
                                 نوع الرهن
                                <small>{{dataItem.MortgageType}}</small>
                            </span> -->
                            <span class="dashboardActionHeading__DataLabel mx-3">
                                رقم:
                                <small>{{dataItem.DocumentNumber}}</small>
                            </span>
                            <span class="dashboardActionHeading__DataLabel mx-5">
                                تاريخ إصدار الوثيقة:
                                <small>   {{ dataItem && dataItem.MortgageIssueHijriDate ? dataItem.MortgageIssueHijriDate.toString().split('T')[0].replaceAll('-', '/') : ''}}</small>
                            </span>
                            <span class="dashboardActionHeading__DataLabel mx-5">
                                جهة الإصدار:
                                <small>{{dataItem.Source}}</small>
                            </span>

                        </div>

                        <div class="col-lg col-sm-3" v-else>

                            <!-- <span class="dashboardActionHeading__DataLabel mx-3">
                                 نوع الرهن
                                <small>{{dataItem.MortgageType}}</small>
                            </span> -->
                            <!-- <span class="dashboardActionHeading__DataLabel mx-3">
                             رقم وثيقة الرهن
                            <small>{{dataItem.ApplicationId}}</small> -->
                            </span>
                            <span class="dashboardActionHeading__DataLabel mx-5">
                                تاريخ إنشاء الطلب:
                                <small>   {{ dataItem && dataItem.RequestCreationHijriDate ? dataItem.RequestCreationHijriDate : ''}}</small>
                            </span>
                            <!-- <span class="dashboardActionHeading__DataLabel mx-5">
                                جهة الإصدار:
                                <small>{{dataItem.Source}}</small>
                            </span> -->
                        </div>

                    </div>

                </div>
            </div>
            <div class="issue issue__v pb-0 mb-3 mt-3" v-if="requestFinished">
                <div class="col-md-12 pr-1 pl-4">
                    <div class="List-alert">
                        <div class="issue__success w-100">
                            <div class="issue__successCircle"></div>
                            <div class="issue__successContent">
                                <h5 class="issue__successTitle mt-2">
                                    {{alertText}}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="issue issue__v pb-0" id="accordionExample7" v-if="dataItem.RequestHistoryLogs !== null">
                <div class="issueTile">
                    <div class="issueTile__wrapper">

                        <div class="issueTile__hide">
                            <div class="issueTile__headingWrapper">
                                <h5 class="issueTile__heading">
                                    <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
                                        <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i> {{dataItem.Status === 3 || dataItem.Status === 4 ? 'سجل الطلب' : 'تتبع الطلب'}} </p>

                                    </button>
                                </h5>
                            </div>
                        </div>

                        <div class="issueTile__content collapse hide" id="collapseSeven" data-parent="#accordionExample7">
                            <div class="timeline-wrapper">
                                <ul class="timeline-list">
                                    <li class="timeline-item">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-check-circle text-primary" aria-hidden="true"></i>
                                        </div>
                                        <div class="timeline-item-body" v-if="!timelineDetailed">
                                            <p class="font-weight-bold mb-0">{{dataItem.RequestHistoryLogs[0].ActionText}}</p>
                                            <p class="font-weight-medium mb-0">{{dataItem.RequestHistoryLogs[0].ActionedByName}}<span style="color: #158e8d;">(المرتهن)</span></p>
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[0].ActionHijriDate}}</p>
                                        </div>
                                        <div class="timeline-item-body" v-else>
                                            <p class="font-weight-bold mb-0">{{dataItem.RequestHistoryLogs[0].ActionText}} <span style="color: #158e8d; font-weight: 400;"> ({{dataItem.RequestHistoryLogs[0].ActionedByName}}) </span></p>
                                            <!-- <p class="font-weight-medium mb-0">{{dataItem.RequestHistoryLogs[0].ActionedByName}}<span style="color: #158e8d;">(المرتهن)</span></p> -->
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[0].ActionHijriDate}}</p>
                                        </div>
                                    </li>
                                    <li class="timeline-item--parent mb-1" id="accordionExample8">
                                        <div class="timeline-item mb-0">
                                            <div class="timeline-item-icon">
                                                <i class="fa fa-clock text-warning" aria-hidden="true"></i>
                                            </div>
                                            <div class="timeline-item-body">
                                                <p class="font-weight-bold mb-0" v-if="(dataItem.Status === 4 || dataItem.Status === 3) && !timelineDetailed">حالة الأعتماد</p>
                                                <p class="font-weight-bold mb-0" v-if="dataItem.Status === 2 && !timelineDetailed">فى انتظار الاعتماد </p>
                                                <p class="font-weight-bold mb-0" v-if="timelineDetailed">اعتماد الطلب من الراهن</p>
                                                <p class="font-weight-bold mb-0" v-if="dataItem.Status === 6 && !timelineDetailed">حالة الاعتماد</p>
                                                <p class="font-weight-light mb-0 text-primary" v-if="(dataItem.Status === 4 || dataItem.Status === 3) && !timelineDetailed">تم الاعتماد من قبل جميع الأطراف</p>
                                                <p class="font-weight-medium mb-1" v-for="(pending, index) in trackingList.pendingUsers" :key="index" v-if="!timelineDetailed">{{pending.Mortgagor.FirstName}} {{pending.Mortgagor.FatherName}} {{pending.Mortgagor.GrandfatherName}} {{pending.Mortgagor.FamilyName}}  <span style="color: #158e8d;">(الراهن)</span></p>

                                            </div>
                                        </div>

                                        <ul class="mt-2" v-if="timelineDetailed">
                                            <li class="timeline-item mb-1" v-for="(doneUser, index) in trackingList.doneUsers" :key="index">
                                                <div class="timeline-item-icon-nested">
                                                    <div class="nested-item-icon" :style="{borderColor: getLogStatusColor(doneUser.Action)}"></div>
                                                </div>
                                                <div class="timeline-item-body">
                                                    <p class="font-weight-bold mb-0">{{doneUser.MortgagorAsText}} <span style="color: #158e8d;" class="font-weight-medium mb-0"> ({{doneUser.ActionedByName}}) </span></p>
                                                    <p class="font-weight-light mb-0" :style="{color: getLogStatusColor(doneUser.Action)}">{{doneUser.ActionText}}</p>
                                                    <p class="font-weight-light mb-0 text--lighten-4">{{doneUser.ActionHijriDate}}</p>

                                                </div>
                                            </li>
                                            <li class="timeline-item mb-1" v-for="(pendingUser, index) in trackingList.pendingUsers" :key="pendingUser.Mortgagor.IdentityNumber">
                                                <div class="timeline-item-icon-nested">
                                                    <div class="nested-item-icon" :style="{borderColor: getLogStatusColor(10)}"></div>
                                                </div>
                                                <div class="timeline-item-body">
                                                    <p class="font-weight-bold mb-0">{{pendingUser.MortgagorAsText}} <span style="color: #158e8d;" class="font-weight-medium mb-0"> ({{pendingUser.Mortgagor.FirstName}} {{pendingUser.Mortgagor.FatherName}} {{pendingUser.Mortgagor.GrandfatherName}} {{pendingUser.Mortgagor.FamilyName}}) </span></p>
                                                    <p class="font-weight-light mb-0" :style="{color: getLogStatusColor(10)}">{{pendingUser.MortgagorActionText}}</p>
                                                    <p class="font-weight-light mb-0 text--lighten-4">{{pendingUser.ActionHijriDate}}</p>

                                                </div>
                                            </li>

                                        </ul>
                                    </li>
                                    <li class="timeline-item mb-1" v-if="dataItem.Status === 3 || dataItem.Status === 4">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-check-circle" aria-hidden="true" style="color: #158e8d;"></i>
                                        </div>
                                        <div class="timeline-item-body" v-if="dataItem.Status === 3">
                                            <p class="font-weight-bold mb-0" v-if="!timelineDetailed">تم إصدار  الرهن رقم ({{dataItem.ApplicationId}}) بنجاح</p>
                                            <p class="font-weight-bold mb-0" v-else>   معتمد و تم إصدار  وثيقة الرهن رقم ({{dataItem.ApplicationId}}) بنجاح</p>
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[dataItem.RequestHistoryLogs.length-1].ActionHijriDate}}</p>
                                        </div>
                                        <div class="timeline-item-body" v-if="dataItem.Status === 4">
                                            <p class="font-weight-bold mb-0" v-if="!timelineDetailed">تم إصدار  الرهن رقم ({{dataItem.ApplicationId}}) بنجاح</p>
                                            <p class="font-weight-bold mb-0" v-else>   معتمد و تم إصدار  وثيقة الرهن رقم ({{dataItem.ApplicationId}}) بنجاح</p>
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[dataItem.RequestHistoryLogs.length-2].ActionHijriDate}}</p>
                                        </div>
                                    </li>
                                    <li class="timeline-item mb-1" v-if="dataItem.Status === 4">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-info-circle text-muted" aria-hidden="true"></i>
                                        </div>
                                        <div class="timeline-item-body">
                                            <p class="font-weight-bold mb-0">منتهي لفك المرتهن للرهن<span style="color: #158e8d; font-weight: 300;">({{dataItem.Morgtgee.InstitutionName}})</span></p>
                                            <p class="font-weight-medium mb-0" style="color: navy;"><i class="fa fa-info ml-2" aria-hidden="true"></i> {{dataItem.Reason}}
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[dataItem.RequestHistoryLogs.length-1].ActionHijriDate}}</p>
                                        </div>
                                    </li>
                                    <li class="timeline-item mb-1" v-if="dataItem.Status === 6 && !timelineDetailed">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-info-circle" aria-hidden="true" style="color: #dc3545;"></i>
                                        </div>
                                        <div class="timeline-item-body">
                                            <p class="font-weight-bold mb-0">{{dataItem.StatusText}} ل{{dataItem.Reason}} <span style="color: #158e8d; font-weight: 300;">({{dataItem.Morgtgee.InstitutionName}})</span></p>
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[dataItem.RequestHistoryLogs.length-1].ActionHijriDate}}</p>
                                        </div>
                                    </li>
                                    <li class="timeline-item mb-1" v-if="dataItem.Status === 6 && timelineDetailed && dataItem.IsReasonAuto">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-info-circle" aria-hidden="true" style="color: #dc3545;"></i>
                                        </div>
                                        <div class="timeline-item-body">
                                            <p class="font-weight-bold mb-0">ملغى من قبل النظام</p>
                                            <template v-for="mortgor in mortegorsCasuingCanecllation">
                                                <p class="font-weight-bold mb-0">{{mortgor.MortgagorAsText}}<span style="color: #158e8d; font-weight: 300;">({{mortgor.Mortgagor.FirstName}} {{mortgor.Mortgagor.FatherName}} {{mortgor.Mortgagor.GrandfatherName}} {{mortgor.Mortgagor.FamilyName}})</span></p>

                                            </template>
                                            <p class="font-weight-bold mb-0" v-if="!mortegorsCasuingCanecllation">صاحب المؤسسة<span style="color: #158e8d; font-weight: 300;">({{dataItem.Morgtgee.InstitutionName}})</span></p>
                                            <p class="font-weight-medium mb-0" style="color: #dc3545;">
                                                <i class="fa fa-info ml-2" aria-hidden="true"></i> {{dataItem.Reason}}
                                            </p>
                                            <p class="font-weight-light mb-0 text--lighten-4">{{dataItem.RequestHistoryLogs[dataItem.RequestHistoryLogs.length-1].ActionHijriDate}}</p>
                                        </div>
                                    </li>
                                    <li class="timeline-item mb-1" v-if="dataItem.Status === 6 && timelineDetailed && !dataItem.IsReasonAuto">
                                        <div class="timeline-item-icon">
                                            <i class="fa fa-info-circle" aria-hidden="true" style="color: #dc3545;"></i>
                                        </div>
                                        <div class="timeline-item-body">
                                            <p class="font-weight-bold mb-0">ملغى لرفض الطلب بواسطة</p>

                                            <ul>
                                                <li class="timeline-item mb-1" v-for="(doneUser, index) in trackingList.doneUsers" :key="index">

                                                    <div class="timeline-item-body" v-if="doneUser.Action === 3">
                                                        <p class="font-weight-medium mb-0">{{doneUser.MortgagorAsText}} <span style="color: #158e8d;" class="font-weight-light mb-0"> ({{doneUser.ActionedByName}}) </span></p>
                                                        <p class="font-weight-light mb-0" :style="{color: getLogStatusColor(doneUser.Action)}"><i class="fa fa-info ml-2" aria-hidden="true"></i>{{dataItem.Reason}}</p>
                                                        <p class="font-weight-light mb-0 text--lighten-4">{{doneUser.ActionHijriDate}}</p>

                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="issue issue__v pb-0" v-if="dataItem.listMortgagor.length > 0" id="accordionExample">
                <div class="issueTile">
                    <div class="issueTile__wrapper">

                        <div class="issueTile__hide">

                            <div class="issueTile__headingWrapper">
                                <h5 class="issueTile__heading">
                                    <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i> بيانات الراهن </p>
                                    </button>
                                </h5>
                            </div>
                        </div>

                        <div class="issueTile__content collapse show" id="collapseOne" data-parent="#accordionExample">
                            <div class="issueTileCards__cont pt-3">

                                <!-- content -->
                                <div class="mb-2 p-2" v-for="mortgagor in dataItem.listMortgagor" :key="mortgagor.CertificateNumber">
                                    <div>
                                        <h5 class="card-title mb-1 d-flex flex-md-row align-items-center justify-content-between mb-2">
                                            <strong class="h5 mb-0 font-weight-bold">
                                                <h5 class="font-weight-bold">
                                                    {{ mortgagor ? mortgagor.Mortgagor.FirstName : '' }}
                                                    {{ mortgagor ? mortgagor.Mortgagor.FatherName : '' }}
                                                    {{ mortgagor ? mortgagor.Mortgagor.FamilyName : '' }}
                                                </h5>
                                            </strong>

                                        </h5>
                                        <div class="cases-parties-pills">
                                            <span class="badge badge-pill badge-light border" v-if=" mortgagor.Mortgagor.IdentityType==1">
                                                نوع الهوية:
                                                هوية وطنية


                                            </span>
                                            <span class="badge badge-pill badge-light border" v-if=" mortgagor.Mortgagor.IdentityType==2">
                                                نوع الهوية:
                                                إقامة

                                            </span>
                                            <span class="badge badge-pill badge-light border">
                                                رقم الهوية:
                                                {{ mortgagor.Mortgagor.IdentityNumber }}
                                            </span>

                                            <span class="badge badge-pill badge-light border">
                                                الجنسية:
                                                {{ mortgagor.Mortgagor.Nationality }}
                                            </span>
                                            <span class="badge badge-pill badge-light border">
                                                الصفة:
                                                {{mortgagor.MortgagorAsText}}
                                            </span>


                                            <span class="badge badge-pill badge-light border" v-if="mortgagor.MortgagorAs==4">
                                                الرقم التسلسلى للمستند: {{ mortgagor.MortgagorAsInfo.CertificateNumber }}
                                            </span>
                                            <span class="badge badge-pill badge-light border" v-if="mortgagor.MortgagorAs==3">
                                                الرقم التسلسلى للمستند: {{ mortgagor.MortgagorAsInfo.WakalaNumber }}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--<div class="issue issue__v pb-0" v-if="dataItem.Company" id="accordionExample2">
                <div class="issue issue__v pb-0" v-if="dataItem.Company  && dataItem.IsCompanies && dataItem.MortgageType == 'الرهن الزراعي' " id="accordionExample2">-->
                    <div class="issue issue__v pb-0" v-if="dataItem.Company && (dataItem.MortgageType == 'الرهن الصناعي' || (dataItem.Company && dataItem.MortgageType == 'الرهن الزراعي'))" id="accordionExample2">

                        <div class="issueTile">
                            <div class="issueTile__wrapper">
                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i> بيانات الشركة</p>

                                            </button>
                                        </h5>
                                    </div>
                                </div>
                                <div class="issueTile__content collapse show" id="collapseTwo" data-parent="#accordionExample2">
                                    <div class="issueTileCards__cont pt-3">
                                        <div class=" mb-2 p-2">
                                            <div>
                                                <!-- <h5 class="card-title mb-1 d-flex flex-md-row align-items-center justify-content-between mb-2">

                                    <strong class="h5 mb-0 font-weight-bold">
                                        {{ dataItem ? dataItem.Company.CompanName : '' }}
                                    </strong>

                                </h5> -->

                                                <div class="cases-parties-pills">
                                                    

                                                    <span class="badge badge-pill badge-light border">
                                                        اسم الشركة / المؤسسة:
                                                        {{  dataItem.Company.CompanName }}
                                                    </span>
                                                    <span class="badge badge-pill badge-light border">
                                                        الرقم الوطني الموحد:
                                                        {{ dataItem.Company.UnifiedNationalNumber }}
                                                    </span>
                                                    <span class="badge badge-pill badge-light border">
                                                        السجل التجاري:
                                                        {{ dataItem.Company.CommercialRegister }}
                                                    </span>



                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="issue issue__v pb-0" v-if="dataItem.Morgtgee" id="accordionExample3">
                        <div class="issueTile">
                            <div class="issueTile__wrapper">
                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i>بيانات المرتهن </p>

                                            </button>
                                        </h5>
                                    </div>
                                </div>

                                <div class="issueTile__content collapse show" id="collapseThree" data-parent="#accordionExample3">
                                    <div class="issueTileCards__cont pt-3 ">

                                        <div class="row">
                                            <div class="col-md-6 mt-md-0 mt-sm-4">
                                                <h6 class="Form__groupTitle mt-0 mb-2"> اسم المنشأة </h6>
                                                <div> {{ dataItem ? dataItem.Morgtgee.InstitutionName : '' }}</div>
                                            </div>

                                            <div class="col-md-6 mt-md-0 mt-sm-4">
                                                <h6 class="Form__groupTitle mt-0 mb-2"> الرقم الوطني الموحد </h6>
                                                <div> {{ dataItem ? dataItem.Morgtgee.InstitutionId : '' }}</div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <!--<div class="issue issue__v pb-0" v-if="dataItem.Company" id="accordionExample4">-->
                    <div class="issue issue__v pb-0" id="accordionExample4">
                        <div class="issueTile">
                            <div class="issueTile__wrapper">

                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i> بيانات الرهن </p>
                                            </button>
                                        </h5>
                                    </div>
                                </div>

                                <div class="issueTile__content collapse show" id="collapseFour" data-parent="#accordionExample4">
                                    <div class="issueTileCards__cont pt-3">
                                        <!-- content -->
                                        <div v-if="dataItem.Loan && dataItem.MortgageType == 'الرهن الصناعي'">
                                            <h3 class="mb-5">بيانات القرض</h3>
                                            <div class="card mb-2 p-2">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2">رقم عقد قرض صندوق التنمية الصناعية السعودي</h6>
                                                            <div> {{ dataItem.Loan.Id}}</div>
                                                        </div>
                                                        <div class="col-md mt-md-0 mt-sm-4" v-if="dataItem.Morgtgee !== null">
                                                            <h6 class="Form__groupTitle mt-0 mb-2">تاريخ توقيع العقد</h6>
                                                            <div v-if="dataItem.MortgageType == 'الرهن الصناعي'"> {{ dataItem && dataItem.Loan ? dataItem.Loan.ContractSigningDate.toString().split('T')[0] : '' }}</div>
                                                        </div>
                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2">  تاريخ أول قسط </h6>
                                                            <div v-if="dataItem.MortgageType == 'الرهن الصناعي'"> {{ dataItem && dataItem.Loan ? dataItem.Loan.FirstInstallmentDate.toString().split('T')[0] : '' }}</div>
                                                        </div>
                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2"> مبلغ القرض </h6>
                                                            <div> {{ dataItem ? dataItem.Loan.LoanAmmount + ' ريال' : '' }}</div>
                                                        </div>
                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2"> جدولة الدفعات </h6>
                                                            <div> {{ dataItem ? dataItem.Loan.SchedulePaymentsText : '' }}</div>
                                                        </div>

                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2"> عدد الأقساط </h6>
                                                            <div>
                                                                {{dataItem ? dataItem.Loan.NumberOfInstallments + ' قسط' : ''}}
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="dataItem.Loan && dataItem.MortgageType == 'الرهن الزراعي'">
                                            <h3 class="mb-5">بيانات التسهيلات الائتمانية</h3>
                                            <div class="card mb-2 p-2">
                                                <div class="card-body">
                                                    <div class="row">

                                                        <div class="col-md mt-md-0 mt-sm-4" v-if="dataItem.Morgtgee !== null">
                                                            <h6 class="Form__groupTitle mt-0 mb-2">تاريخ سداد مبلغ التمويل</h6>
                                                            <div> {{ dataItem && dataItem.Loan.DateOfPaymentOfFinancingAmount ? dataItem.Loan.DateOfPaymentOfFinancingAmount.toString().split('T')[0] : '' }}</div>
                                                        </div>
                                                        <div class="col-md mt-md-0 mt-sm-4">
                                                            <h6 class="Form__groupTitle mt-0 mb-2">مبلغ التمويل</h6>
                                                            <div> {{ dataItem ? dataItem.Loan.LoanAmmount + ' ريال' : '' }}</div>
                                                        </div>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--overflow="scroll"-->
                                        <h3 class="mb-5 mt-6">بيان بالأعيان </h3>
                                        <div v-if="dataItem.MortgageType == 'الرهن الصناعي'" style="max-height: 400px;overflow-y: auto;">
                                            <!-- <h5 class="Form__groupTitle mt-0 mb-2"> {{  dataItem.Company.CompanName  }} </h5>-->
                                            <div class="card mb-4 p-2" v-for=" ayan in dataItem.Ayans">

                                              

                                                <div class="card-body px-5">
                                                    <div class="row ">
                                                        <h6 class="Form__groupTitle mt-0 mb-2 border-bottom  py-3">
                                                            {{ ayan.NameArabic }}
                                                        </h6>
                                                        <div v-for="subAyan in ayan.SubAyans" class="mt-1 mb-3">
                                                            <h5 class="card-title mb-1 d-flex flex-md-row align-items-center justify-content-between mb-2">
                                                                <strong class="h5 mb-0 font-weight-bold">
                                                                    {{ subAyan.NameArabic }}
                                                                </strong>
                                                            </h5>
                                                            <div class="cases-parties-pills row mt-1">
                                                                <span class="badge-light border col-12 mb-1" style="max-width: 200ch; word-break:break-word;border-radius: 40px; ">
                                                                    {{ subAyan.Details }}
                                                                </span>
                                                                <span class="badge badge-pill badge-light border">
                                                                    العدد:
                                                                    {{ subAyan.Count }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-if="dataItem.MortgageType == 'الرهن الزراعي'" style="max-height: 400px;overflow-y: auto;">
                                            <!-- <h5 class="Form__groupTitle mt-0 mb-2"> {{  dataItem.Company.CompanName  }} </h5>-->
                                            <div class="card mb-4 p-2" v-for=" ayan in dataItem.Ayans">

                                                

                                                <div class="card-body px-5">
                                                    <div class="row ">
                                                        <h6 class="Form__groupTitle mt-0 mb-2 border-bottom  py-3">
                                                            {{ ayan.MainAyanName }} / {{ayan.PurposeAyanName}}
                                                        </h6>
                                                        <div class="mt-1 mb-3">
                                                            <h5 class="card-title mb-1 d-flex flex-md-row align-items-center justify-content-between mb-2">
                                                                <strong class="h5 mb-0 font-weight-bold">
                                                                    {{ ayan.SubAyanName }}
                                                                </strong>
                                                            </h5>
                                                            <div class="cases-parties-pills row mt-1">
                                                                <span class="badge-light border col-12 mb-1" style="max-width: 200ch; word-break:break-word;border-radius: 40px; ">
                                                                    {{ ayan.Details }}
                                                                </span>
                                                                <span class="badge badge-pill badge-light border">
                                                                    العدد:
                                                                    {{ ayan.Quantity }}
                                                                </span>
                                                            </div>
                                                            <div class="cases-parties-pills row mt-1" v-if="ayan.IsFactory">

                                                                <!--<span class="badge badge-pill badge-light border">
                                                    المنطقة:
                                                    {{ ayan.Region }}
                                                </span>-->
                                                                <!--<span class="badge badge-pill badge-light border">
                                                    المدينة:
                                                    {{ ayan.City }}
                                                </span>-->
                                                                <span class="badge badge-pill badge-light border">
                                                                    الموقع:
                                                                    {{ ayan.Location }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>


                    <div class="issue issue__v pb-0" v-if="dataItem.listMortgagor.length > 0" id="accordionExample5">
                        <div class="issueTile">
                            <div class="issueTile__wrapper">

                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i> <span> الحائز </span>  ( الراهن ) </p>

                                            </button>
                                        </h5>
                                    </div>
                                </div>

                                <div class="issueTile__content collapse show" id="collapseFive" data-parent="#accordionExample5">
                                    <div class="issueTileCards__cont pt-3 ">
                                        <div class="card haiizCard">
                                            <div class="card-body">
                                                <div class=" mt-md-0 mt-sm-4">
                                                    <span> {{ GetHaizDisplayText(dataItem) }}</span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="issue issue__v pb-0" v-if="isMortgageCanceled" id="accordionExample6">
                        <div class="issueTile">
                            <div class="issueTile__wrapper">
                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i>سبب إلغاء الطلب</p>

                                            </button>
                                        </h5>
                                    </div>
                                </div>

                                <div class="issueTile__content collapse show" id="collapseSix" data-parent="#accordionExample6">
                                    <div class="List-alert">
                                        <div class="issue__warning w-100 m-0" style="border-right: 5px solid #6c757d">
                                            <div class="issue__warningCircle" style="border: 2px solid #6c757d; color: #6c757d; background-color: rgba(108,117,125,.1);">!</div>
                                            <div class="issue__warningContent">
                                                <h5 class="issue__warningTitle">
                                                    {{ dataItem.Reason }}
                                                </h5>
                                                <p class="issue_alertDescription" v-if="dataItem.Reason">
                                                    {{ dataItem.ReasonDetails }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="issue issue__v pb-0" v-if="isMortgageExpired" id="accordionExample7">
                        <div class="issueTile">
                            <div class="issueTile__wrapper">
                                <div class="issueTile__hide">
                                    <div class="issueTile__headingWrapper">
                                        <h5 class="issueTile__heading">
                                            <button class="btn  btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                                <p class="issueTile__heading font-weight-bold mb-0"> <i class=" icon icon-arrow_up ml-2"></i>سبب إنهاء الرهن </p>

                                            </button>
                                        </h5>
                                    </div>
                                </div>


                                <div class="issueTile__content collapse show" id="collapseSix" data-parent="#accordionExample7">
                                    <div class="List-alert">
                                        <div class="issue__warning w-100 m-0" style="border-right: 5px solid #868686;">
                                            <div class="issue__warningCircle" style="border: 2px solid #868686;background-color:#fff; color: #ababab;">!</div>
                                            <div class="issue__warningContent">
                                                <h5 class="issue__warningTitle">
                                                    {{ dataItem.Reason }}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="issue issue__v pb-0 mb-3 mt-3" v-if="canApproveRejectMortgages">
                        <div class="col-md-12" style="border-bottom: 2px solid #e2dcbf;">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="consentCheck" v-model="checked"
                                       class="custom-control-input" required>
                                <label for="consentCheck" class="custom-control-label">
                                    <h5>
                                        أقرّ بصحة البيانات والمعلومات المدخلة، كما أقرّ بعلمي التام بالآثار النظاميّة المترتبة على هذه العمليّة التوثيقيّة، ومنها أن الوثيقة التي ستصدر لهذا الرهن تعدّ سندًا تنفيذيًّا تسري عليها أحكام الأنظمة ذات الصلة بالتنفيذ
                                    </h5>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="issue issue__v" style="display: flex; flex-direction: row; align-items: center; justify-content:flex-end;" v-if="canApproveRejectMortgages">
                        <button type="button" @click="ApproveRejectwithOTP('RejectMortgages')"
                                class="btn btn-outline-danger btn-default mx-4 py-1 px-5">
                            إلغاء الطلب
                        </button>
                        <button type="button" @click="ApproveRejectwithOTP('ApproveMortgages')"
                                class="btn btn-primary text-white py-1 px-5">
                            قبول الطلب
                        </button>

                    </div>

                </div>

        <div class="m-3 h-100" v-if="showUpdateSuccessResult">
            <div class="d-flex align-items-stretch h-100 issueTile__wrapper">

                <div class="d-flex align-items-center w-100">
                    <div class="issueTile px-0 text-center">
                        <div>
                            <i class="fa fa-check fa-5x text-primary m-1">
                            </i>
                        </div>
                        <h2 class="m-3">
                            <strong v-if="openStep == 'RejectMortgages'">
                                تم إلغاء الطلب بنجاح
                            </strong>
                            <strong v-else>
                                تم إعتماد الطلب بنجاح
                            </strong>
                        </h2>
                        <!--<h4 class="m-2">
                            <strong>
                                تم إصدار  الاقرار رقم {{newIqrarNumber}} بنجاح
                            </strong>
                        </h4>-->

                        <template v-if="eId != '' && eKey != ''">
                            <a href="https://najiz.sa" class="btn btn-sm btn-primary text-white m-4">
                                العودة للصفحة الرئيسية
                            </a>
                        </template>

                        <template v-else>
                            <router-link class="btn btn-sm btn-primary text-white m-4" :to="'/'">
                                العودة للصفحة الرئيسية
                            </router-link>
                        </template>

                    </div>
                </div>

            </div>

        </div>

        <v-dialog class="dialog-class" v-model="openCloseDialog" max-width="500">
            <v-card>
                <v-card-title>
                    <div>
                        <strong> {{$t('mortgages.mortgage.approveTitle')}}</strong>
                    </div>
                    <!--<div style="position: absolute;left: 15px;top: 10px;">
                        <button @click="closeDialog">
                            <v-icon>mdi-close</v-icon>
                        </button>
                    </div>-->
                </v-card-title>

                <div v-if="showCancellationReasonDiv">

                    <div class="profile__container mt-0">

                        <div v-if="openStep == 'RejectMortgages' && cancellationReasons && cancellationReasons.length > 0">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="text-center font-weight-bold" style="color: #158e8d;">تحديد سبب الإلغاء</h4>
                                </div>
                                <div class="col-md-12">

                                    <select class="form-control custom-select" @input="onSelectedCancelReasonChange">
                                        <option value="">   سبب الإلغاء </option>
                                        <option v-for="option in cancellationReasons" :value="option.Id">{{ option.Arabic }}</option>
                                    </select>
                                    <!--<v-select id="cancelReasonList" :items="cancellationReasons" v-model="selectedCancellationReasonObj" item-value="Id" item-text="Arabic" @change="onSelectedCancelReasonChange" return-object></v-select>-->
                                </div>

                            </div>
                            <div class="row" v-if="selectedCancellationReason == 1">
                                <div class="col-md-12">
                                    <textarea v-model="cancelationDetails" placeholder="تفاصيل طلب الالغاء" rows="2" class="form-control" required></textarea>
                                </div>
                            </div>
                            <div class="profile__buttons justify-content-end pt-3">


                                <button class="button button--radius btn-link mr-5" @click="closeDialog">
                                    <span class="button__buttonText" style="color: red">
                                        إغلاق
                                    </span>
                                </button>
                                <button class="button button--radius button--greenFill" @click="sendCancelationOTP" :disabled="disableSendCancelationOTPButton">
                                    <span class="button__buttonText">
                                        تحقق
                                    </span>
                                </button>
                            </div>

                        </div>

                    </div>
                </div>

                <div v-if="showOTPDiv">

                    <div class="profile__container mt-0">

                        <div class="row">
                            <div class="col-md-12 text-center">
                                <p class="text-center font-weight-bolder" style="color: #158e8d;">
                                    {{$t('mortgages.mortgage.EnterOTP')}}
                                    <br />
                                </p>
                            </div>
                            <div class="col-md-12 text-center">
                                <input type="text"
                                       ref="txtOtpCode"
                                       v-mask="'######'"
                                       v-model="otpCode"
                                       maxlength="6"
                                       class="form-control text-center"
                                       @keyup="verifyOnEnter" />
                            </div>
                            <!-- <div class="col-md-12 optWrapper">
                                <form>
                                    <input type="text" v-for="(otpNumber, index) in otpCodeArray" :key="index" v-model="otpCodeArray[index]" @change="getOtpData" class="otpInput" pattern="[0-9]+" >
                                </form>

                            </div> -->
                            <div class="col-md-12 text-center">
                                <small class="form-text text-muted text-center" v-if="timeToExpire !== '0'">
                                    {{$t('mortgages.mortgage.expireTime') }} {{timeToExpire}}
                                </small>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="button button--radius btn-link m-auto" @click="resendOTP" :disabled="disableResend" style="color: #158e8d;">
                                    <span class="button__buttonText">
                                        إعادة إرسال رمز التحقق
                                    </span>
                                </button>
                            </div>



                        </div>

                    </div>

                    <div class="profile__buttons justify-content-end py-3 px-5">
                        <button class="button button--radius btn-link mr-5 px-2 py-2  " @click="closeDialog">
                            <span class="button__buttonText" style="color: red">
                                الغاء
                            </span>
                        </button>

                        <button class="button button--radius button--greenFill px-2 py-2  " @click="VerifyOTP">
                            <span class="button__buttonText">
                                تحقق
                            </span>
                        </button>
                    </div>


                </div>

                <div v-if="showNafathDiv" style="text-align: center; padding: 20px;">

                    <p v-if="!nafathErrorMessage" style="font-weight: bold; color: #158e8d; font-size: 18px;">
                        الرجاء فتح تطبيق نفاذ وتأكيد الطلب باختيار الرقم الظاهر
                    </p>

                    <p v-if="nafathErrorMessage" style="font-weight: bold; color: red; font-size: 18px;">
                        {{ nafathErrorMessage }}
                    </p>

                    <div v-if="!nafathErrorMessage" style="display: inline-block; background-color: #158e8d; padding: 20px 40px; border-radius: 20px; margin: 20px 0;">
                        <span style="font-size: 3rem; color: white;">{{ nafathCode }}</span>
                    </div>

                    <div>
                        <button style="background: none; border: none; color: red; font-size: 16px; cursor: pointer;" @click="cancelNafath">
                            إلغاء
                        </button>
                    </div>

                </div>


                <!--<div v-if="showOTPDiv" style="text-align: center; padding: 20px;">

                    <p style="font-weight: bold; color: #158e8d; font-size: 18px;">
                        الرجاء فتح تطبيق نفاذ وتأكيد الطلب باختيار الرقم الظاهر
                    </p>

                    <div style="display: inline-block; background-color: #158e8d; padding: 20px 40px; border-radius: 20px; margin: 20px 0;">
                        <span style="font-size: 3rem; color: white;">{{ nafathCode }}</span>
                    </div>

                    <div>
                        <button style="background: none; border: none; color: red; font-size: 16px; cursor: pointer;" @click="cancelNafath">
                            إلغاء
                        </button>
                    </div>

                </div>-->



            </v-card>
        </v-dialog>
    </div>


    <div v-else>
        <div class="m-3 h-100">
            <div class="d-flex align-items-stretch h-100 issueTile__wrapper">

                <div class="d-flex align-items-center w-100">
                    <div class="issueTile px-0 text-center">
                        <div>
                            <i class="far fa-times-circle fa-5x text-danger m-1"></i>
                        </div>
                        <h2 class="m-3">
                            <strong>
                                لم يتم العثور على الصفحة المطلوبة
                            </strong>
                        </h2>
                        <!--<h4 class="m-2">
                            <strong>

                            </strong>
                        </h4>-->

                    </div>
                </div>

            </div>

        </div>
    </div>


</div>
